import {call, select, put} from 'redux-saga/effects';
import {api} from "../../../api/api";
import {RootState} from "../../../store/rootReducer";
import {cardsActions} from "../../cards.slice";
import {SetMarkupPayload} from "../../../common";

export function* saveSaga() {
    const props = (yield select((state: RootState) => ({
        cardId: state.cardEditor.cardId,
        markup: state.cardEditor.markup,
    }))) as { cardId: string, markup: string };

    try {
        const payload: SetMarkupPayload = {
            cardId: props.cardId,
            markup: props.markup,
        };
        
        yield call([api, api.setMarkup], payload);

        yield put(cardsActions.setMarkup({
                cardId: props.cardId,
                markup: props.markup,
            }));

        window.history.back();
    } catch {
        // Обработка ошибки без использования console.error
        // Можно добавить диспатч действия для отображения ошибки пользователю
    }
}
